import { environment } from 'src/config';

export const getAuthClientDetails = (isAuthenticated?: boolean) => {
  // For dev environments, we use an unauthenticated request and set the Authorization in the header manually (see withDevAuth)
  const useDevAuth =
    environment === 'development' ||
    environment === 'dev' ||
    environment === 'dark-prod';
  return {
    isAuthenticatedClient: isAuthenticated && ENV.CLIENT && !useDevAuth,
    useDevAuth,
  };
};
